// Keep app-specific diagnostics while delegating transport, consent, queueing,
// PHI filtering and autocapture to the same pinned SDK as MindVault.
import { EVENTS as SHARED_EVENTS } from 'tikcare-analytics';
export { init, track, trackPageView, flush } from 'tikcare-analytics';

export const EVENTS = Object.freeze({
  ...SHARED_EVENTS,
  LIVE_STARTUP_DIAGNOSTIC: 'live_startup_diagnostic',
  REFINEMENT_DIAGNOSTIC: 'refinement_diagnostic',
  TRANSCRIPT_SAVE_FAILED: 'transcript_save_failed',
});
